module.exports = __webpack_public_path__ + "img/individual-1.82b4f41.webp";